import { ArticleParagraph3, Button } from '@cian/ui-kit';

import { FC } from 'react';

import { IFormFooterWithPrivacyPolicyProps } from './types';

import * as styles from './FormFooterWithPrivacyPolicy.css';

export const FormFooterWithPrivacyPolicy: FC<IFormFooterWithPrivacyPolicyProps> = props => {
  const { submitButtonTitle, buttonDisabled, onButtonClick } = props;

  return (
    <div className={styles['form-footer']}>
      <div className={styles['privacy-policy-container']}>
        <ArticleParagraph3 as="span" color="black_100" fontWeight="normal">
          Нажимая на кнопку «{submitButtonTitle}», вы принимаете условия
        </ArticleParagraph3>
        <ArticleParagraph3 as="span" color="black_100" fontWeight="normal">
          <a
            className={styles['privacy-policy-link']}
            href="/legal-documents/licenzionnoe_soglashenie_0/"
            target="_blank"
          >
            пользовательского соглашения
          </a>
          {' и '}
          <a
            className={styles['privacy-policy-link']}
            href="/legal-documents/politika_konfidencialnosti_0/"
            target="_blank"
          >
            политики конфиденциальности
          </a>
        </ArticleParagraph3>
      </div>
      <div className={styles['submit-button-container']}>
        <Button
          data-testid="submit-button"
          disabled={buttonDisabled}
          size="XS"
          theme="fill_primary"
          type="submit"
          onClick={onButtonClick}
        >
          {submitButtonTitle}
        </Button>
      </div>
    </div>
  );
};

FormFooterWithPrivacyPolicy.displayName = 'FormFooterWithPrivacyPolicy';
